import React from 'react';
import MessageBar from './MessageBar';
import { useMessages } from "../../Providers/MessagesProvider";

const MessageCenter: React.FC = () => {
  const { messages, removeMessage } = useMessages();

  return (
    <div style={{ zIndex: 9999 }}>
      {messages.map((msg) => (
        <MessageBar key={msg.key} message={msg} onDismiss={removeMessage} />
      ))}
    </div>
  );
};

export default MessageCenter;
